<div class="px-7 pt-4 transition-[margin-right] duration-300"
     [style.margin-right]="mergePanelOpen ? '360px' : '0'">
  <!-- Toolbar -->
  <div class="flex items-center gap-2.5 py-3.5 flex-wrap">
    <!-- Add Samples Button -->
    <button *ngIf="submissionStatus < 2" (click)="openAddSamplesDialog()"
      class="py-2 px-3.5 bg-[var(--primary-dark)] rounded-lg text-xs font-semibold text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      <span class="material-icons text-[16px]">add</span> ADD SAMPLES
    </button>

    <!-- Search -->
    <div class="relative">
      <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
      <input type="text" placeholder="Search samples..." [(ngModel)]="searchText" (ngModelChange)="searchLabSamples()"
        class="py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] focus:border-[var(--primary-dark)] text-[var(--base-text-alt-dark)]">
    </div>

    <!-- Clear Filters -->
    <button *ngIf="isFilterBtnVisible" (click)="resetFilter()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">filter_alt_off</span> Clear Filters
    </button>

    <div class="flex-1"></div>

    <!-- Date Range -->
    <div class="flex gap-2.5 items-center">
      <ui-datepicker label="START DATE" [value]="filterStartDate" (valueChange)="filterStartDate=$event; filterDateRange()"></ui-datepicker>
      <ui-datepicker label="END DATE" [value]="filterEndDate" (valueChange)="filterEndDate=$event; filterDateRange()"></ui-datepicker>
    </div>
  </div>

  <!-- Samples Table -->
  <!-- Sample order controls. Shown only once there is something to order, and
       kept out of the picker dialog, which has no submission to order.

       $any() because dataSource is declared MatTableDataSource on this component
       but is actually assigned the raw paged response, which carries content and
       totalElements. Left as-is rather than retyped, since the table reads it
       through callResponse the same way. -->
  <div class="flex items-center gap-2 mb-3" *ngIf="$any(dataSource)?.content?.length">
    <button (click)="saveOrder()" [disabled]="!orderDirty || savingOrder"
      class="px-4 py-2 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition disabled:bg-[#E6E6E6] disabled:text-[#C3C3C3]">
      {{ savingOrder ? 'Saving...' : 'Save Order' }}
    </button>
    <button (click)="resetOrder()" [disabled]="savingOrder"
      class="px-4 py-2 rounded-lg text-[13px] font-medium border border-[var(--app-border)] text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] transition">
      Reset to Default
    </button>
    <span *ngIf="orderDirty" class="text-[12px] font-medium text-[#DC2626]">Unsaved order changes</span>
  </div>

  <app-samples-table
    [submissionStatus]="submissionStatus"
    [callResponse]="dataSource"
    [pinTypeId]="pinTypeId"
    [isDialog]="false"
    [mergeGroups]="mergeGroups"
    (emitSelectedSamples)="removeSamplesDialog($event)"
    (mergeSamples)="mergeSamples($event)"
    (unmergeSamples)="unmergeSamples($event)"
    (removeSample)="removeSampleDialog($event)"
    (orderChanged)="onOrderChanged($event)"
    (viewMergeGroup)="viewMergeGroup($event)"
    (paginateChange)="currentPage=$event.currentPage;pageSize=$event.pageSize;getLabSampleListById();">
  </app-samples-table>

  <!-- Linked samples are excluded from the list above, so this is the only place
       in Lab Manager where a merged group can actually be read. -->
  <app-merge-panel [open]="mergePanelOpen"
                   [group]="mergePanelGroup"
                   [canUnmerge]="canUnmerge"
                   (unmergeMember)="unmergeMember($event)"
                   (closed)="closeMergePanel()"></app-merge-panel>
</div>
